import {DashboardRepository} from '../repositories/DashboardRepository';
import {DashboardData} from '../entities/DashboardData';

export class GetDashboardDataUseCase {
  constructor(private readonly dashboardRepository: DashboardRepository) {}

  async execute(): Promise<DashboardData> {
    return await this.dashboardRepository.getDashboardData();
  }
}

